import React, { useEffect, useState } from 'react'
import * as PosService from '../../Services/pos-service';
import PosRequestChangePersonalTable from './pos-request-change-personal-table';
import { FormControl, Grid, RadioGroup } from '@mui/material';
import CustomRadio from '../../Components/custom-radio/CustomRadio';
import { CustomTextField } from '../../Components/custom-textfield/CustomTextField';
import { CustomAutocomplete } from '../../Components/custom-combobox/CustomAutocomplete';
import Calendar from '../../Components/custom-calendar/Calendar';
import { t } from 'i18next';
import { CustomHelpText } from '../../Components/custom-help-text/CustomHelpText';
function PosRequestChangePersonal({ objectDto, setObjectDto, lang }) {
    const windowSize = PosService.getSizeWindows();
    const [fullname, setFullname] = useState("");
    const [gender, setGender] = useState("");
    const [birth, setBirth] = useState(null);
    const [id, setId] = useState("");
    const [typeId, setTypeId] = useState("");
    const [placeId, setPlaceId] = useState("");
    const [dateId, setDateId] = useState(null);
    const [check, setCheck] = useState(false);
    const handleResetValue = () => {
        setFullname(''); setGender(''); setBirth(null); setId(''); setTypeId(''); setDateId(null); setPlaceId('');
        setTypeSubSelected(''); setSelectedValue(''); setCheck(false);
    }
    const [selectedValue, setSelectedValue] = useState('');
    const [typeSubSelected, setTypeSubSelected] = useState('');
    function onValueRadioChange(event) {
        setSelectedValue(event.target.value);
    }
    useEffect(() => {
        if (selectedValue === "radioPOInfo") {
            setTypeSubSelected(lang('policyowner'))
        } else if (selectedValue === "radioLAInfo") {
            setTypeSubSelected(lang('policylife'))
        } else if (selectedValue === "radioBenInfo") {
            setTypeSubSelected(lang('policybeneficiary'))
        }
    }, [selectedValue]);

    return (
        <div style={{ display: "block", borderBottom: "2px solid #c4960c", marginBottom: "1%" }}>
            <div data-toggle="collapse" data-target="#search-box-3" className={"header-box"} id="search-box-3-header">
                <h2 className="title-box description-large-customer">
                    {lang('poschangeinformation').toUpperCase()}
                </h2>
            </div>
            <div className={"collapse in"} id="search-box-3">
                <Grid container spacing={1} className='border-box-sc row' sx={{ paddingLeft: "10px", paddingRight: "10px", marginBottom: "15px" }}>
                    <Grid item xs={12}>
                        <FormControl fullWidth disabled={objectDto.saved === 1}>
                            <RadioGroup sx={{
                                "& .MuiTypography-root": {
                                    "fontSize": "14px",
                                    "@media (max-width: 960px) and (min-width: 688px)": {
                                        fontSize: "12px",
                                    },
                                    "@media (max-width: 687px)": {
                                        fontSize: "10px",
                                    },
                                }
                            }} row={windowSize[0] > 991 ? true : false} value={selectedValue} onChange={onValueRadioChange}>
                                <Grid item xs={12} sm={4} align="left" className="">
                                    <CustomRadio title={lang('policyowner')} value="radioPOInfo" className={"minimal"} id={"radioPOInfo"} />
                                </Grid>
                                <Grid item xs={12} sm={4} align="left" className="">
                                    <CustomRadio title={lang('policylife')} value="radioLAInfo" className="minimal" id="radioLAInfo" />
                                </Grid>
                                <Grid item xs={12} sm={4} align="left" className="">
                                    <CustomRadio title={lang('policybeneficiary')} value="radioBenInfo" className="minimal" id="radioBenInfo" />
                                </Grid>
                            </RadioGroup>
                        </FormControl>
                    </Grid>
                    {selectedValue !== '' ?
                        <>
                            <Grid item xs={12} sm={6} style={{ paddingLeft: "5px", paddingRight: "5px", marginTop: "-10px", paddingBottom: "10px" }}>
                                <CustomTextField variant="outlined" label={lang('fullname')} focusColor="#c4960c" required value={fullname} size="small" fullWidth
                                    onChange={(e) => PosService.handleChangeEventValue(e, setFullname)}
                                    helperText={check === true && fullname === '' ? t('NotEmptyjavalangString') : ''} />
                            </Grid>
                            <Grid item xs={12} sm={3} style={{ paddingLeft: "5px", paddingRight: "5px", marginTop: "-10px", paddingBottom: "10px" }} >
                                <CustomAutocomplete title={lang('gender')} value={gender !== '' ? gender : ''} data={[lang('male'), lang('female')]}
                                    handleChange={(e) => PosService.handleChangeEventTextContent(e, setGender)}
                                />
                                <CustomHelpText exist={gender} hidden={gender === '' && check === true} />
                            </Grid>
                            <Grid item xs={12} sm={3} style={{ paddingLeft: "5px", paddingRight: "5px", marginTop: "-10px", paddingBottom: "10px" }} >
                                <Calendar title="Ngày sinh" value={birth} handleChange={(value) => setBirth(value)} />
                                <CustomHelpText exist={birth} hidden={(birth === '' || birth === null) && check === true} />
                            </Grid>
                            <Grid item xs={12} sm={3} style={{ paddingLeft: "5px", paddingRight: "5px", marginTop: "-10px", paddingBottom: "10px" }} >
                                <CustomTextField variant="outlined" label={lang('idnumber')} value={id} required fullWidth size="small" focusColor="#c4960c"
                                    onChange={(e) => PosService.handleChangeEventValue(e, setId)}
                                    helperText={check === true && id === '' ? t('NotEmptyjavalangString') : ''}
                                />
                            </Grid>
                            <Grid item xs={12} sm={3} style={{ paddingLeft: "5px", paddingRight: "5px", marginTop: "-10px", paddingBottom: "10px" }} >
                                <CustomAutocomplete title={lang('idtype')} data={["CMND", "CCCD", "Hộ chiếu"]} value={typeId !== '' ? typeId : ''}
                                    handleChange={(e) => PosService.handleChangeEventTextContent(e, setTypeId)}
                                />
                                <CustomHelpText exist={typeId} hidden={typeId === '' && check === true} />
                            </Grid>

                            <Grid item xs={12} sm={3} style={{ paddingLeft: "5px", paddingRight: "5px", marginTop: "-10px", paddingBottom: "10px" }}>
                                <Calendar title="Ngày cấp" value={dateId} handleChange={(value) => setDateId(value)} />
                                <CustomHelpText exist={dateId} hidden={(dateId === '' || dateId === null) && check === true} />
                            </Grid>
                            <Grid item xs={12} sm={3} style={{ paddingLeft: "5px", paddingRight: "5px", marginTop: "-10px", paddingBottom: "10px" }}>
                                <CustomTextField variant="outlined" label={lang('idplace')} value={placeId} required size="small" fullWidth focusColor="#c4960c"
                                    onChange={(e) => PosService.handleChangeEventValue(e, setPlaceId)}
                                    helperText={check === true && placeId === '' ? t('NotEmptyjavalangString') : ''} />
                            </Grid>
                            <Grid item xs={12} sm={12} align="center" marginBottom={objectDto.changePersonalDetail !== undefined && objectDto.changePersonalDetail.length > 0 ? "0px" : "5px"}>
                                <a id="btnAddPersonal" className="btn-common btn-search"
                                    onClick={() => {
                                        if (!PosService.ValidatePersonal(birth, id, typeId, gender, fullname, dateId, placeId)) {
                                            PosService.ChangePersonalList(objectDto, setObjectDto, fullname, gender, birth, id, typeId, dateId, placeId, typeSubSelected, selectedValue);
                                            handleResetValue();
                                        } else {
                                            setCheck(true)
                                        }
                                    }}>
                                    <i className="fa fa-plus" />{" "}
                                    <span title="button.check">
                                        {lang('posaddchange')}
                                    </span>
                                </a>
                            </Grid>
                        </>
                        : <></>}
                    <Grid className='col-md-12' item xs={12} sm={12} id="changePersonalTable" align="center" style={{ marginTop: "10px", paddingLeft: "0px", paddingRight: "0px", width: "300px" }} display={objectDto.changePersonalDetail !== undefined && objectDto.changePersonalDetail.length > 0 ? "block" : "none"}>
                        <PosRequestChangePersonalTable objectDto={objectDto} setObjectDto={setObjectDto} />
                    </Grid>
                </Grid>
            </div>
        </div >
    )
}

export default PosRequestChangePersonal